import axios from 'axios';
import { lockScroll, unlockScroll } from './scrollBlocker';
import Swiper from 'swiper';
import { slideToggle } from './slide-toggle';
import viewport from './viewport';

export default function() {
    const modalOpenBtns = Array.from(document.querySelectorAll('.js-wholesale-modal-open'));

    let currentModal = null;
    let slider = null;

    async function loadModalContent(url) {
        try {
            const response = await axios.get(url);

            showWholeSaleModal(response.data);
        } catch (err) {
            console.error('Error while getting data by ajax', err.message);
        }
    }

    function wholesaleModalScripts(modal) {
        const sliderContainer = modal.querySelector('.swiper-container');

        if (slider) slider.destroy(true);
        slider = new Swiper(sliderContainer, {
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true
            }
        });

        $(modal.querySelector('input[type="number"]')).styler();

        $(modal.querySelector('input.js-number-input')).on('change', function() {
            let $currentInput = $(this);
            let currentVal = parseInt($currentInput.val());
            let currentMin = parseInt($currentInput.attr('min'));
            let currentMax = parseInt($currentInput.attr('max'));

            setTimeout(function() {
                $currentInput
                    .closest('.jq-number')
                    .find('.jq-number__spin')
                    .removeClass('disabled');
            }, 5);

            if (currentVal > currentMax) {
                currentVal = currentMax;
                $currentInput.val(currentMax);
            }
            if (currentVal < currentMin) {
                currentVal = currentMin;
                $currentInput.val(currentMin);
            }
            if (currentVal == currentMin) {
                setTimeout(function() {
                    $currentInput
                        .closest('.jq-number')
                        .find('.minus')
                        .addClass('disabled');
                }, 5);
            }
            if (currentVal == currentMax) {
                setTimeout(function() {
                    $currentInput
                        .closest('.jq-number')
                        .find('.plus')
                        .addClass('disabled');
                }, 5);
            }
        });

        $(modal.querySelector('input.js-number-input')).each(function() {
            let $currentInput = $(this);
            let currentVal = parseInt($currentInput.val());
            let currentMin = parseInt($currentInput.attr('min'));
            let currentMax = parseInt($currentInput.attr('max'));
            if (currentVal == currentMin) {
                setTimeout(function() {
                    $currentInput
                        .closest('.jq-number')
                        .find('.minus')
                        .addClass('disabled');
                }, 5);
            }
            if (currentVal == currentMax) {
                setTimeout(function() {
                    $currentInput
                        .closest('.jq-number')
                        .find('.plus')
                        .addClass('disabled');
                }, 5);
            }
        });

        $(modal.querySelector('.js-number-input, input[type="tel"]')).keydown(function(event) {
            if (event.keyCode == 46 || event.keyCode == 8 || event.keyCode == 9 || event.keyCode == 27 || event.keyCode == 13 || (event.keyCode == 65 && event.ctrlKey === true) || (event.keyCode >= 35 && event.keyCode <= 39)) {
                return;
            } else {
                if (event.shiftKey || ((event.keyCode < 48 || event.keyCode > 57) && (event.keyCode < 96 || event.keyCode > 105))) {
                    event.preventDefault();
                }
            }
        });

        let accordionTitleMobile = modal.querySelectorAll('.js-mobile-accordion');

        Array.from(accordionTitleMobile).forEach(button =>
            button.addEventListener('click', function(e) {
                let currentBtn = this.parentNode;
                if (viewport().width < 576) {
                    slideToggle(this.nextElementSibling, 500, function() {
                        currentBtn.classList.toggle('is-opened');
                    });
                }
                e.preventDefault();
            })
        );

        const selectTasteRedirects = modal.querySelector('.js-wholesale-modal-select-taste');

        if (selectTasteRedirects) {
            const radioBtns = Array.from(selectTasteRedirects.querySelectorAll('input[type="radio"]'));

            radioBtns.forEach(radio =>
                radio.addEventListener('change', event => {
                    const modalToOpen = radio.getAttribute('data-open-modal');

                    console.log('Modal to open', modalToOpen);

                    if (!modalToOpen) return;

                    closeCurrentModal().then(() => {
                        console.log('Current modal closed');
                        // loadModalContent(modalToOpen);
                        setTimeout(() => {
                            loadModalContent(modalToOpen);
                        }, 600);
                    });
                })
            );
        }
    }

    function showWholeSaleModal(content) {
        const modalWrapper = document.createElement('div');
        modalWrapper.className = 'wholesale-modal-wrapper';

        modalWrapper.innerHTML = content;

        document.body.appendChild(modalWrapper);

        const modal = modalWrapper.querySelector('.wholesale-modal');
        wholesaleModalScripts(modal);
        modal && modal.scrollTop;
        lockScroll(modal);
        modal.classList.add('shown');

        currentModal = modalWrapper;

        const showModalEvent = new CustomEvent('showmodal');

        document.documentElement.dispatchEvent(showModalEvent);
    }

    function closeCurrentModal() {
        return new Promise((resolve, reject) => {
            if (!currentModal) reject();
            const modal = currentModal.querySelector('.wholesale-modal');

            const modalRemoveTransitionEndHandler = () => {
                currentModal.remove();
                currentModal = null;
                modal.removeEventListener('transitionend', modalRemoveTransitionEndHandler);
                const closeModalEvent = new CustomEvent('closemodal');

                document.documentElement.dispatchEvent(closeModalEvent);

                resolve();
            };

            modal && modal.scrollTop;

            modal.addEventListener('transitionend', modalRemoveTransitionEndHandler);
            modal.classList.remove('shown');
            unlockScroll();
        });
    }

    document.addEventListener('click', event => {
        if (event.target.matches('.wholesale-modal') && currentModal) {
            closeCurrentModal();
        }
        if (event.target.matches('.wholesale-modal__close') || event.target.closest('.wholesale-modal__close')) {
            closeCurrentModal();
        }
    });

    document.addEventListener('keydown', evt => {
        if (evt.keyCode === 27) {
            if (currentModal) closeCurrentModal();
        }
    });

    modalOpenBtns.forEach(element => {
        element.addEventListener('click', event => {
            event.preventDefault();

            const href = element.href;

            if (!href) {
                console.warn('Href is empty');
                return;
            }

            loadModalContent(href);
        });
    });
}
